import { ReactComponent as OnlineBankingPL } from 'static/images/logos/payments/onlineBankingPL.svg';
import styled from 'styled-components';

function OnlineBankingPLComponent({ white }) {
   return (
     <Root white={white}>
       <OnlineBankingPL />
     </Root>
   );
 }
 
 export default OnlineBankingPLComponent;

 const Root = styled.div`
 svg {
   path {
     fill: white !important;

     ${({ white }) =>
       white &&
       `
       fill: white !important;
       opacity: 0.5 !important;
     `}
   }
 }
`;